import { useForm, UseFormProps } from 'react-hook-form';

import {
  createAccountValidationSchema,
  CreateAccountFormValues,
} from './createAccountValidationSchema';
import {
  emptyBankAccountRow,
  emptyDependentRow,
} from './entityFormDefaults';
import { useYupValidationResolver } from 'custom-hooks';


export const createAccountFormDefaultValues: CreateAccountFormValues = {
  name: '',
  entity_type: '',
  status: '',
  stage: '',
  is_restricted_account: false,

  website: '',
  phone_number: '',
  fax_number: '',
  referral_source: '',
  rating: '',
  external_account_id: '',

  address_line_1: '',
  address_line_2: '',
  address_city: '',
  address_state: '',
  address_zip: '',
  address_country: '',

  encryptedCoEin: '',
  co_industry: '',
  co_prior_accountant: '',
  co_number_of_employees: '',
  co_fiscal_yearend: '',
  co_biggest_challenges: '',
  co_biz_decision_tools_used: '',
  co_expectations: '',

  co_tech_accounting: '',
  co_tech_expenses: '',
  co_tech_time_trackings: '',
  co_tech_payroll: '',
  co_tech_billpay: '',

  bankAccounts: [{ ...emptyBankAccountRow }],

  taxpayer_first_name: '',
  taxpayer_middle_name: '',
  taxpayer_last_name: '',
  in_curr_filling_status: '',
  encryptedInSelfSsn: '',
  in_self_birthdate: '',
  in_self_driver_license: '',
  in_self_license_issue_date: '',
  in_self_license_expiry_date: '',
  in_self_license_state: '',

  in_sps_first_name: '',
  in_sps_middle_name: '',
  in_sps_last_name: '',
  encryptedInSpsSsn: '',
  in_sps_birthdate: '',
  in_sps_driver_license: '',
  in_sps_license_issue_date: '',
  in_sps_license_expiry_date: '',
  in_sps_license_state: '',
  in_sps_address_line_1: '',
  in_sps_address_line_2: '',
  in_sps_address_city: '',
  in_sps_address_state: '',
  in_sps_address_zip: '',
  in_sps_address_country: '',

  dependents: [{ ...emptyDependentRow }],
};

/**
 * Shared react-hook-form setup for create-account fields.
 * Wrap children with FormProvider from the returned methods.
 */
export function useCreateAccountForm(
  options?: Omit<UseFormProps<CreateAccountFormValues>, 'resolver'>
) {
  return useForm<CreateAccountFormValues>({
    defaultValues: createAccountFormDefaultValues,
    resolver: useYupValidationResolver(createAccountValidationSchema),
    mode: 'onChange',
    ...options,
  });
}
